import React, { useEffect, useLayoutEffect, useState } from 'react'
import { validateValue } from '../../login/Validations';
import { useForm } from "../../../components/forms/Form";
import styles from './authentication.module.css'
import { useAppContext } from "../../../components/activity/AppContext";
import AuthenticationActions from './authentication.actions';
import CustomAuth from './customAuth';
import OAuth from './oAuth';
import PopUp from '../../../components/layouts/PopUp';
import UserMapping from './UserMapping';

export default function AuthenticationPopUp(props) {
    const {perm, authMasterData, popUp, setPopUp,isEdit,editData} = props
    // const [authMasterData, setAuthMasterData] = useState([]);
    const [currentAuthData, setCurrentAuthData] = useState({});
    const [authData, setAuthData] = useState(isEdit ? {...editData , entityId:""} : {authName:authMasterData[0]?.name, id: "", name: "", config: "",entityId:""});
    const [submit, setSubmit] = useState(true);
    const [disableTextarea, setDisableTextarea] = useState(false)
    const [renderComponent,setRenderComponent] = useState("")
    const [connectionStatus, setConnectionStatus] = useState(false);
    const [oAuthData, setOAuthData] = useState({});
    const [saml,setSaml] = useState(false)
    const [fields, setFields] = useState({});
    const [systemFields, setSystemFields] = useState([]);

    const app = useAppContext();

    const getAuthenticationCurrentData = async () => {
        const actions = AuthenticationActions(app());
        const [, data] = await actions.readAuthenticationData();
        if(data)
        setCurrentAuthData(data?.detail);
    }

    const fetchAuthenticationData = () => {
        // getAuthenticationMasterData();
        getAuthenticationCurrentData();
    }

    useEffect(() => fetchAuthenticationData(), []);

    const handleAuthData = () => {
        // for (let i = 0; i < authMasterData.length; i++) {
        //     if (currentAuthData.authId === authMasterData[i].id) {
        //         setAuthData({ id: currentAuthData.authId, name: authMasterData[i].name, config: currentAuthData.config||"",entityId:currentAuthData.entityId||"" });
        //     }
        // }
    }

    useEffect(() => handleAuthData(), [authMasterData, currentAuthData]);

    const closePopup = ()=>{
        setRenderComponent("")
    }

    const onWatch = (errors, data) => {
         if(data.name === "name"){
            errors.set(data.name,"")
         }
        if (data.value === "Custom Authentication" || data.value === "OAuth Authentication" || data.value === "Saml2 Authentication") {
            // setRenderComponent(data.value)
            setDisableTextarea(true)
        } else {
            setRenderComponent("")
            setDisableTextarea(false)
        }
        validateValue(errors, data.name, data.value);
        authData[data.name] = data.value;
        if (data.name === "name") {
            if (Array.isArray(authMasterData) && authMasterData.length > 0) {
                for (let i = 0; i < authMasterData.length; i++) {
                    if (data.value && data.value === authMasterData[i].name) {
                        if (authMasterData[i].id) {
                            authData["id"] = authMasterData[i].id;
                            setAuthData({ ...authData, id: authMasterData[i].id });
        
                            if (currentAuthData && authMasterData[i].id === currentAuthData.authId) {
                                setAuthData({
                                    ...authData,
                                    config: currentAuthData.config || "",
                                    entityId: currentAuthData.entityId || "",
                                });
                            } else {
                                setAuthData({ ...authData, config: "", entityId: "" });
                            }
                        }
                    }
                }
            }
        }
        
    }

  

    const onSubmit = async (values, errors) => {
        if(!values.name){
            errors.set("name","Invalid Name")
        }
        if(values.name){
            let updateValues = !isEdit ? { authName: values.authName ? values.authName : authMasterData[0]?.name , config: values.config , entityId: values.entityId , name:values.name , description:values.description}:
            { id:editData.id,authName: values.authName ? values.authName : authMasterData[0]?.name , config: values.config , entityId: values.entityId , name:values.name , description:values.description}
            const actions = AuthenticationActions(app());
            const update = actions.validateAuthChanges(values, currentAuthData, "submit");
            if (update) {
                const [, data] =isEdit ? await actions.updateAuthentication({...updateValues,id:editData.id}) :  await actions.createAuthentication(updateValues)
                if (data){
                    fetchAuthenticationData();
                    setPopUp()
                } 
            }

        }
    }

    const handleCancel = () => {
        const actions = AuthenticationActions(app());
        const update = actions.validateAuthChanges(authData, currentAuthData, "cancel");
        if (update) handleAuthData();
    }


    const { Form, Select,Input, TextArea, Label, Error , errors } = useForm(authData, onSubmit, onWatch);

    const handleNext = () =>{
        if(!authData.name){
            errors.set('name',"Invalid Name")
        }
        else{
            setRenderComponent(authData.authName)
        }
    }

    useEffect(() => {
        setAuthData(isEdit ? { ...editData } : { id: "", name: "", config: "", entityId: "" });
      }, [isEdit, editData]);

    const handleCloseSaml = ()=>{
         setPopUp()
         setSystemFields([])
      }

      const handleClose = ()=>{
        setPopUp();
        setSystemFields([])
      }

     


    return (
            <PopUp popUp={popUp} setPopUp={handleClose} title={isEdit ? "Edit Auth Configuration" : "Auth Configuration"}>
                <div className={styles.authInnerCon} >
                    <Form>

                    <Label text="Authentication Type" htmlFor="authName" />
                        <Select 
                            data-option-testid="Authenticationtype" 
                            id="authName" 
                            name="authName" 
                            defaultValue={""} 
                            className={styles.uniformWidth}
                            style={{width:"100%"}}
                            disabled={editData.authName === "FM Authentication"}
                            >
                                {
                                  editData.authName === "FM Authentication" ?    <option value="FM Authentication">
                                  FM Authentication
                               </option>: authMasterData && authMasterData.map((item) => (
                                <option key={item.id} value={item.name}>{item.name}</option>
                                ))
                                }
                               
                           
                        </Select>
                    <Label text="Name" htmlFor="Name" />
                        <Input 
                            type="text" 
                            id="Name" 
                            name="name" 
                            placeholder="Name"
                            defaultValue={authData?.name || ""}
                            className={styles.uniformWidth} 
                        />
                        <Error name="name" />

                        <Label text="Description" htmlFor="Description" />
                        <Input 
                            id="Description" 
                            type="text" 
                            name="description" 
                            placeholder="Description"  
                            defaultValue={authData?.description || ""}
                            className={styles.uniformWidth} 
                        />
                        <Error name="description" />

                        <Label text="Entity ID" htmlFor="config" />
                        <Input 
                            type="text" 
                            id="entityId" 
                            name="entityId" 
                            disabled={disableTextarea} 
                            placeholder="Entity ID" 
                            defaultValue={authData.entityId} 
                            className={styles.uniformWidth} 
                        />
                        <Error name="entityId" />

                   

                        <Label text="URL" htmlFor="config" />
                        <TextArea 
                            data-input-testid="URL" 
                            id="config" 
                            type="text" 
                            name="config" 
                            maxLength={250} 
                            placeholder="URL" 
                            disabled={disableTextarea} 
                            defaultValue={authData.config} 
                            className={styles.uniformWidth} 
                        />
                        <Error name="config" />
                        <div style={{height:"80px"}}></div>

                        <div className={styles.submitContainer} style={{zIndex:100,backgroundColor:"white"}}>
                                {/* <input data-clickable-testid="cancel" className='secondary' type="button" value="Cancel" onClick={handleCancel} /> */}
                                {perm?.canUpdate ? (
                                    authData.authName === "Custom Authentication" || authData.authName === "OAuth Authentication" || authData.authName === "Saml2 Authentication"  ? (
                                        <input 
                                        data-clickable-testid="next" 
                                        type="button" 
                                        className={submit ? "primary" : "tertiary"} 
                                        value="Next" 
                                        onClick={handleNext}
                                        />
                                    ) : (
                                        <input 
                                        data-clickable-testid={isEdit ? "Update" : "Save"}
                                        type="submit" 
                                        className={submit ? "primary" : "tertiary"} 
                                        value={isEdit ? "Update" : "Save"}
                                        />
                                    )
                                    ) : null}

                       </div>
                    </Form>
                    
                    {renderComponent === "Custom Authentication" && (
                        <CustomAuth
                            renderComponent={renderComponent}
                            closePopup={closePopup}
                            authData={authData}
                            currentAuthData={currentAuthData}
                            fetchAuthenticationData={fetchAuthenticationData}
                            isEdit={isEdit}
                            setPopUp={setPopUp}
                        />
                    )}
                    {renderComponent === "OAuth Authentication" && (
                        <OAuth
                            renderComponent={renderComponent}
                            closePopup={closePopup}
                            authData={authData}
                            currentAuthData={currentAuthData}
                            fetchAuthenticationData={fetchAuthenticationData}
                            setPopUp={setPopUp}
                            setAuthData={setAuthData}
                            connectionStatus={connectionStatus}
                            setConnectionStatus={setConnectionStatus}
                            oAuthData={oAuthData}
                            setOAuthData={setOAuthData}
                            isEdit={isEdit}
                        />
                    )}

                
                    {
                        renderComponent === "Saml2 Authentication" && (
                            <UserMapping
                                currentAuthData={currentAuthData}
                                setPopUp={handleCloseSaml}
                                renderComponent={renderComponent}
                                authData={authData}
                                fetchAuthenticationData={fetchAuthenticationData}
                                handleClose={closePopup}
                                isEdit={isEdit}
                                fields={fields}
                                setFields={setFields}
                                systemFields={systemFields}
                                setSystemFields={setSystemFields}

                        />
                        )
                    }
                  
                    </div>
            </PopUp>
    )
}
